"use client";

/**
 * Serves the static ESG 2026 mindmap (from terry-esg) as-is in a full-viewport frame.
 */
function Esg2026Page() {
  return (
    <iframe
      src={`${process.env.PUBLIC_URL || ""}/esg2026/index.html`}
      title="ESG Journey as an Architect"
      className="fixed inset-0 h-dvh w-screen border-0"
      allowFullScreen
    />
  );
}

export default Esg2026Page;
